import type { Difficulty, Profile, TrainingProgram, WorkoutExerciseResult, WorkoutRecord } from '../types'

export function createAnalysisExport(
  profile: Profile,
  program: TrainingProgram,
  workouts: WorkoutRecord[],
  results: WorkoutExerciseResult[]
) {
  const completed = workouts.filter((workout) => !workout.skipped)
  const dates = workouts.map((workout) => workout.date).sort()
  const lastObservedDay = workouts.length ? Math.max(...workouts.map((workout) => workout.day)) : 0
  const plannedSessions = program.schedule.filter((day) => day.day <= lastObservedDay && day.kind !== 'REST').length
  return {
    schemaVersion: 1,
    period: { from: dates[0] || program.startDate, to: dates.at(-1) || program.startDate },
    profile: { heightCm: profile.heightCm, weightKg: profile.weightKg },
    program: { name: program.name, version: program.version },
    summary: {
      plannedSessions,
      completedSessions: completed.length,
      modifiedSessions: workouts.filter((workout) => workout.modified).length,
      skippedSessions: workouts.filter((workout) => workout.skipped).length,
      averageDurationMin: completed.length ? Math.round(completed.reduce((sum, item) => sum + item.durationMin, 0) / completed.length) : 0
    },
    workouts: workouts.map((workout) => ({
      date: workout.date,
      day: workout.day,
      sessionType: workout.actualSession,
      originalSession: workout.originalSession,
      dailyMode: workout.dailyMode,
      recommendationReason: workout.recommendationReason,
      modified: workout.modified,
      minimal: workout.minimal,
      durationMin: workout.durationMin,
      energyBefore: workout.energyBefore,
      energyAfter: workout.energyAfter,
      overallDifficulty: workout.overallDifficulty as Difficulty | undefined,
      kneeBefore: workout.kneeBefore,
      kneeDuring: workout.kneeDuring,
      kneeAfter: workout.kneeAfter,
      exercises: results.filter((result) => result.workoutId === workout.id).map((result) => ({
        exerciseId: result.exerciseId,
        plannedSets: result.plannedSets,
        actualSets: result.actualSets,
        difficulty: result.difficulty,
        rir: result.rir,
        pain: result.pain,
        skipped: result.skipped,
        notes: result.notes
      })),
      notes: workout.notes
    }))
  }
}
